function getBattery(item) {
    const val = parseInt((item.dynamicAttributes || {}).battery, 10);
    return isNaN(val) ? 0 : val;
}

function applyPercentileFilter(data, percentile) {
    if (!percentile || !data || data.length === 0) return data || [];
    const sorted = [...data].sort((a, b) => getBattery(a) - getBattery(b));
    const cutoff = Math.ceil(sorted.length * (percentile / 100));
    return sorted.slice(0, cutoff);
}

export { applyPercentileFilter };



// WEBPACK FOOTER //
// ./src/components/devicemanagement/ledcontrollerstag/CartFilterUtils.js